import React from 'react';
import { t } from '@lingui/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { StandAloneCalculator } from 'components/StandAloneCalculator/StandAloneCalculator';

import styles from './calculator.module.css';

export const CalculatorPage = () => {
  return (
    <BaseLayout
      className={styles.container}
      pageTitle={t`Calculator | Introducer Portal`}
    >
      <StandAloneCalculator />
    </BaseLayout>
  );
};
